'use es6';

import { Promise } from '../../../lib/promise';
import { get as responseSize } from './response-size';
const preconditions = [responseSize];
export const get = (spec, config) => response => {
  preconditions.forEach(condition => condition(spec, config)(response));
  return Promise.resolve(response);
};